import { Injectable } from '@angular/core';
import { RunStep, WorkflowV1Run } from '@ca/core/models';
import { getRunSteps, getSelectedModules } from '@ca/utils';
import clone from 'clone-deep';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { WorkflowV1Service } from '.';
import { WorkflowRunService } from './workflow-run.service';
import { WorkflowRunnerStepBuilderService } from './workflow-runner-step-builder.service';
import { WorkflowStateService } from './workflow-state.service';

@Injectable()
export class AriApplicationService {
    constructor(
        private workflowRunnerStepBuilderService: WorkflowRunnerStepBuilderService,
        private workflowRunService: WorkflowRunService,
        private workflowStateService: WorkflowStateService,
        private workflowV1Service: WorkflowV1Service,
    ) {}

    startAriApplicationByWorkflow$(
        workflowId: string,
        images: string[],
        applicationRunName: string,
        notifyWhenIsDone: boolean,
        modelId?: string,
    ): Observable<{ workflowRunId: string }> {
        return this.workflowV1Service.getById(workflowId).pipe(
            switchMap(workflow => {
                const runSteps = this.setInputForWorkflow(workflow, images);
                return this.startAriApplicationWithPreparedRunSteps$(workflow, runSteps, applicationRunName, notifyWhenIsDone, modelId);
            }),
        );
    }

    private startAriApplicationWithPreparedRunSteps$(
        workflow: WorkflowV1Run,
        runSteps: RunStep[],
        applicationRunName: string,
        notifyWhenIsDone: boolean,
        modelId?: string,
    ): Observable<{ workflowRunId: string }> {
        // We need this because usually we start a workflow from Editor/Runner (and this stores the current workflow in the workflowStateService).
        // Since we start a workflow here without accessing Editor/Runner, we need to store this workflow manually.
        this.workflowStateService.storeWorkflow(workflow);

        return this.workflowRunService.startWorkflowRun(
            runSteps,
            false,
            applicationRunName,
            undefined,
            undefined,
            undefined,
            undefined,
            notifyWhenIsDone,
            undefined,
            undefined,
            undefined,
            modelId,
        );
    }

    private setInputForWorkflow(workflow: WorkflowV1Run, inputImagesUrls: string[]): RunStep[] {
        // We need to clone the objects, because since they're coming from ngrx store, they are not mutable.
        const clonedWorkflow: WorkflowV1Run = clone(workflow);
        const selectedModules = getSelectedModules(workflow);
        const runSteps: RunStep[] = getRunSteps(clonedWorkflow, selectedModules);

        this.workflowRunnerStepBuilderService.addFileUrlToSystemModule([...inputImagesUrls], runSteps[0], 'file_list');

        return runSteps;
    }
}
